import { motion } from "framer-motion";
import { Syringe, TestTube, HeartPulse, ShieldCheck, Pill, Stethoscope } from "lucide-react";

const otherServices = [
  { icon: Syringe, label: "Injections", desc: "Sous-cutanées, intramusculaires, anticoagulants" },
  { icon: HeartPulse, label: "Soins de nursing", desc: "Toilettes, aide et surveillance quotidienne" },
  { icon: Pill, label: "Préparation de piluliers", desc: "Gestion et suivi de vos traitements" },
  { icon: ShieldCheck, label: "Soins post-opératoires", desc: "Suivi de sortie d'hospitalisation" },
  { icon: Stethoscope, label: "Surveillance clinique", desc: "Constantes, tension, accompagnement" },
];

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const OtherServices = () => {
  return (
    <section
      data-testid="other-services-section"
      className="py-20 sm:py-24 bg-[#FAF9F6]"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-12">
          <div className="max-w-xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#3F9E8E] mb-4">
              Tous nos soins
            </p>
            <h2 className="font-display font-bold text-3xl sm:text-4xl tracking-tight text-[#2C362B] leading-tight">
              Une prise en charge complète
            </h2>
          </div>
          <p className="text-sm text-[#7C877C] max-w-xs sm:text-right">
            Tous nos actes sont réalisés sur prescription médicale et remboursés.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {otherServices.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.label}
                data-testid={`other-service-${i}`}
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-60px" }}
                custom={i}
                className="flex items-start gap-4 bg-white rounded-2xl p-6 border border-[#E0E0D8] shadow-[0_4px_20px_rgb(0,0,0,0.03)] hover:border-[#3F9E8E]/40 transition-colors duration-200"
              >
                <span className="flex-shrink-0 grid place-items-center w-11 h-11 rounded-xl bg-[#E3E7E0] text-[#6B7A66]">
                  <Icon className="w-5 h-5" strokeWidth={1.75} />
                </span>
                <div>
                  <h3 className="font-semibold text-[#2C362B]">{s.label}</h3>
                  <p className="mt-1 text-sm text-[#4A554A] leading-snug">{s.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
